"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MANAGE_RECURRING_REDESIGN_COPY = exports.MANAGE_RECURRING_COPY = exports.RECURRING_CHARGES_FOOTNOTE_REDESIGN_COPY = exports.RECURRING_CHARGES_SCOPE_REDESIGN_COPY = exports.RECURRING_CHARGES_FOOTNOTE_COPY = exports.RECURRING_CHARGES_SCOPE_COPY = exports.RECURRING_CHARGES_ERROR_COPY = exports.RECURRING_CHARGES_EMPTY_COPY = exports.RECURRING_CHARGES_AVG_LABEL_COPY = exports.RECURRING_CHARGES_COUNT_LABEL_COPY = exports.RECURRING_CHARGES_TITLE_COPY = exports.RECURRING_CHARGES_ENTRY_COPY = void 0;
exports.recurringChargesAcross = recurringChargesAcross;
exports.recurringChargesScopeCopy = recurringChargesScopeCopy;
exports.recurringChargesFootnoteCopy = recurringChargesFootnoteCopy;
exports.manageRecurringCopy = manageRecurringCopy;
const navTabsCopy_1 = require("./navTabsCopy");
/**
 * The Insights view of detected recurring charges (BEN-141 FP-132, Paul 2026-10-07,
 * option A).
 *
 * The wants breakdown's "Subscriptions" row is a spending category and now opens
 * that category (FP-132). The view of detected recurring streams (Netflix,
 * Spotify…) was also titled "Subscriptions", reached by "Review your
 * subscriptions": two screens with one name and different figures. This view
 * takes its own name, and the category keeps its (a category name is data).
 * One key, so both clients' entry points and screens say the same thing.
 */
exports.RECURRING_CHARGES_ENTRY_COPY = "Review recurring charges";
exports.RECURRING_CHARGES_TITLE_COPY = "Recurring charges";
exports.RECURRING_CHARGES_COUNT_LABEL_COPY = "Charges";
exports.RECURRING_CHARGES_AVG_LABEL_COPY = "Avg per charge";
exports.RECURRING_CHARGES_EMPTY_COPY = "No recurring charges detected yet.";
exports.RECURRING_CHARGES_ERROR_COPY = "Couldn't load your recurring charges";
/**
 * The subtitle's tail after "About $26": "a month across the 2 recurring charges we
 * detected, like streaming and memberships." It says what kind of charge this view holds
 * (Paul, 2026-10-07: "say what's in it"), because the sidebar's Recurring page lists
 * every recurring bill and this view shows only the detected subscription-like ones.
 */
function recurringChargesAcross(count) {
    return `a month across the ${count} recurring ${count === 1 ? "charge" : "charges"} we detected, like streaming and memberships.`;
}
/**
 * Its own line under the subtitle. Without it, someone who sees rent missing from
 * "Recurring charges" can think the view lost their bills (Paul, 2026-10-07).
 */
exports.RECURRING_CHARGES_SCOPE_COPY = "Rent and your other bills are on the Recurring page.";
/**
 * The footnote under the list. It said "Manage or cancel any subscription from your
 * recurring transactions": a leftover "subscription" on this view (FP-132), and
 * "cancel" claimed more than the app does (it stops tracking a charge, it can't
 * cancel one).
 */
exports.RECURRING_CHARGES_FOOTNOTE_COPY = "These are suggestions. Manage any of these charges on the Recurring page.";
/**
 * FP-193 (mobile, 2026-10-15): with the redesign switch on, the page these name is
 * Bills & income under Upcoming, not "the Recurring page". Each client picks by its flag.
 */
exports.RECURRING_CHARGES_SCOPE_REDESIGN_COPY = `Rent and your other bills are on ${navTabsCopy_1.NAV_REPEATING_COPY} in ${navTabsCopy_1.NAV_UPCOMING_COPY}.`;
exports.RECURRING_CHARGES_FOOTNOTE_REDESIGN_COPY = `These are suggestions. Manage any of these charges on ${navTabsCopy_1.NAV_REPEATING_COPY} in ${navTabsCopy_1.NAV_UPCOMING_COPY}.`;
/** The view's button to the page that manages recurring payments. */
exports.MANAGE_RECURRING_COPY = "Manage recurring";
exports.MANAGE_RECURRING_REDESIGN_COPY = `Manage in ${navTabsCopy_1.NAV_REPEATING_COPY}`;
function recurringChargesScopeCopy(redesign) {
    return redesign
        ? exports.RECURRING_CHARGES_SCOPE_REDESIGN_COPY
        : exports.RECURRING_CHARGES_SCOPE_COPY;
}
function recurringChargesFootnoteCopy(redesign) {
    return redesign
        ? exports.RECURRING_CHARGES_FOOTNOTE_REDESIGN_COPY
        : exports.RECURRING_CHARGES_FOOTNOTE_COPY;
}
function manageRecurringCopy(redesign) {
    return redesign ? exports.MANAGE_RECURRING_REDESIGN_COPY : exports.MANAGE_RECURRING_COPY;
}
//# sourceMappingURL=recurringChargesCopy.js.map